import * as React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { stackoverflowLight } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export const Code = (code: string, theme) => {
	return (
		<SyntaxHighlighter
			language="htmlbars"
			style={stackoverflowLight}
			customStyle={{
				'padding': '1em',
				'margin-bottom': '0',
				'background': theme.colors.lighter,
			}}
		>
			{code}
		</SyntaxHighlighter>
	);
};
